import HomeView from '@/views/frontend/Home.vue'
import AboutView from '@/views/frontend/About.vue'
import VendorsView from '@/views/frontend/Vendors.vue'
import ForVendorsView from '@/views/frontend/ForVendors.vue'
import ForUsersView from '@/views/frontend/ForUsers.vue'
import VendorDetailView from '@/views/frontend/VendorDetail.vue'
import VendorSearchView from '@/views/frontend/VendorSearch.vue'
import VenueSearchView from '@/views/frontend/VenueSearch.vue'
import VenuesView from '@/views/frontend/Venues.vue'
import VenueInviteDetailView from '@/views/frontend/VenueInviteDetail.vue'
import ServiceVendorInviteDetailView from '@/views/frontend/ServiceVendorInviteDetail.vue'
import CategoriesView from '@/views/frontend/Categories.vue'
import BlogView from '@/views/frontend/Blog.vue'
import BlogDetailView from '@/views/frontend/BlogDetail.vue'
import ContactView from '@/views/frontend/Contact.vue'
import SupportView from '@/views/frontend/Support.vue'
import PrivacyPolicyView from '@/views/frontend/PrivacyPolicy.vue'
import TermsView from '@/views/frontend/Terms.vue'
import UseCasesView from '@/views/frontend/UseCases.vue'
import UseCaseDetailView from '@/views/frontend/UseCaseDetail.vue'
import FaqsView from '@/views/frontend/Faqs.vue'
import PricingView from '@/views/frontend/Pricing.vue'
import LoginView from '@/views/frontend/Login.vue'
import RegisterView from '@/views/frontend/Register.vue'
import ForgotPasswordView from '@/views/frontend/ForgotPassword.vue'
import NotFoundView from '@/views/frontend/NotFound.vue'

const frontendRoutes = [
  { path: '/', name: 'home', component: HomeView, meta: { layout: 'frontend' } },
  { path: '/i/:eventid/:token?', name: 'public-invitation', component: () => import('@/views/user/PublicLink.vue'), meta: { layout: 'frontend' } },
  { path: '/qr-link/:eventid/:userid?', name: 'public-qr-link', component: () => import('@/views/user/PublicQrLink.vue'), meta: { layout: 'plain' } },
  { path: '/about', name: 'about', component: AboutView, meta: { layout: 'frontend' } },
  { path: '/vendors', name: 'vendors', component: VendorsView, meta: { layout: 'frontend' } },
  { path: '/for-vendors', name: 'for-vendors', component: ForVendorsView, meta: { layout: 'frontend' } },
  { path: '/for-users', name: 'for-users', component: ForUsersView, meta: { layout: 'frontend' } },
  { path: '/vendors/:slug', name: 'vendors-slug', component: VendorsView, meta: { layout: 'frontend' } },
  { path: '/vendor/:id', name: 'vendor-detail', component: VendorDetailView, meta: { layout: 'frontend' } },
  { path: '/vendor-search', name: 'vendor-search', component: VendorSearchView, meta: { layout: 'frontend' } },
  { path: '/venue-search', name: 'venue-search', component: VenueSearchView, meta: { layout: 'frontend' } },
  { path: '/venues', name: 'venues', component: VenuesView, meta: { layout: 'frontend' } },
  { path: '/venues/detail/:venueId', alias: ['/venue/detail/:venueId', '/venue/:venueId'], name: 'venue-invite-detail', component: VenueInviteDetailView, meta: { layout: 'frontend' } },
  { path: '/service-vendors/detail/:serviceVendorId', name: 'service-vendor-invite-detail', component: ServiceVendorInviteDetailView, meta: { layout: 'frontend' } },
  { path: '/categories', name: 'categories', component: CategoriesView, meta: { layout: 'frontend' } },
  { path: '/blog', name: 'blog', component: BlogView, meta: { layout: 'frontend' } },
  { path: '/blog/:slug', name: 'blog-detail', component: BlogDetailView, meta: { layout: 'frontend' } },
  { path: '/contact', name: 'contact', component: ContactView, meta: { layout: 'frontend' } },
  { path: '/support', name: 'support', component: SupportView, meta: { layout: 'frontend' } },
  { path: '/privacy-policy', name: 'privacy-policy', component: PrivacyPolicyView, meta: { layout: 'frontend' } },
  { path: '/terms', name: 'terms', component: TermsView, meta: { layout: 'frontend' } },
  { path: '/use-cases/:slug', name: 'use-case-detail', component: UseCaseDetailView, meta: { layout: 'frontend' } },
  { path: '/use-cases', name: 'use-cases', component: UseCasesView, meta: { layout: 'frontend' } },
  { path: '/faqs', name: 'faqs', component: FaqsView, meta: { layout: 'frontend' } },
  { path: '/pricing', name: 'pricing', component: PricingView, meta: { layout: 'frontend' } },
  { path: '/404', name: 'frontend-404', component: NotFoundView, meta: { layout: 'frontend' } },
  { path: '/login', name: 'login', component: LoginView, meta: { layout: 'auth' } },
  { path: '/register', name: 'register', component: RegisterView, meta: { layout: 'auth' } },
  { path: '/forgot-password', name: 'forgot-password', component: ForgotPasswordView, meta: { layout: 'auth' } }
]

export default frontendRoutes
